import React from 'react'

import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image
} from '@react-pdf/renderer'

import moment from 'moment'

import ManpowerLogo from '../../../../../assets/images/logos/pdf_img.png'
// import Header from '../../../Components/Header'
// import Footer from '../../../Components/Footer'

const styles = {
    defaultFontSize: {
        fontSize: '12'
    }
}

const ImmediateTerminationLetter = ({ associateName, incident, dateOfIncident, remarks=null }) => {
    return (
        <Document
            author="Manpower"
            subject="Immediate Termination Letter">
            <Page size="A4" style={{ padding: '20px 50px 20px 50px', display: 'flex', flexDirection: 'column' }}>
                {/* <Header /> */}
                <View style={{display: 'flex', flexDirection: 'row', marginBottom: 20}}>
                    <View style={{width: "70%"}}>
                        {/* <Image cache={false} src={'https://helpx.adobe.com/content/dam/help/en/stock/how-to/visual-reverse-image-search/jcr_content/main-pars/image/visual-reverse-image-search-v2_intro.jpg'}  /> */}
                    </View>
                    <View style={{ width: '30%', fontSize: 10, paddingBottom: 4}}>
                        <Text>Manpower</Text>
                        <Text>1 Wallich Street</Text>
                        <Text>#09-02 Guoco Tower</Text>
                        <Text style={{paddingBottom: 5}}>Singapore 079903</Text>

                        <Text>T: +65 6232 8811</Text>
                        <Text>F: +65 6232 8804</Text>
                        <Text>www.manpower.com.sg</Text>
                    </View>
                </View>
                {/* pnc */}
                <View>
                    <Text style={{ fontWeight: 'bold', width: "100%", fontSize: 13, marginBottom: 30 }}>PRIVATE & CONFIDENTIAL</Text>
                </View>
                <View style={{marginBottom: 15}}>
                    {/* date */}
                    <Text style={{marginBottom: 30, fontSize: 11}}>{moment().format('DD MMMM YYYY')}</Text>
                    {/* associate name */}
                    {/* <Text>Bhusham S/O Ramsaran</Text> */}
                    {/* associate address */}
                    {/* <Text></Text> */}
                    {/* dear associate name */}
                    <Text style={{fontSize: 11}}>Dear {associateName},</Text>
                    {/* title */}
                </View>
                <View style={{marginBottom: 15}}>
                    <Text style={{ fontWeight: 'bold', fontSize: 13, paddingTop: 10, paddingBottom: 10}}>TERMINATION OF CONTRACT</Text>
                </View>
                <View style={{marginBottom: 10}}>
                    <Text style={{ width: '100%', lineHeight: 1.2, fontSize: 11}}>
                        The Company hereby serves you a termination notice with immediate effect due to a breach of contract whereby you are {incident} on {dateOfIncident}. 
                    </Text>
                    
                    <Text style={{ width: '100%', lineHeight: 1.2, fontSize: 11, paddingTop: 10}}>
                        {remarks}
                    </Text>
                    
                    <Text style={{ width: '100%', lineHeight: 1.2, fontSize: 11, paddingTop: 10}}>
                        In accordance to the Employment Act, you have breached your Contract of Service and thus you are required to pay the Company 2 weeks salary.
                        You may write a cheque payable to “Manpower Staffing Services (Singapore) Pte Ltd or transfer the money to our bank account which the details as follow:
                    </Text>
                </View>
                <View style={{ flexDirection: 'row', width: '100%', lineHeight: 1.2, marginTop: 14, fontSize: 11}}>
                    <View style={{width: '30%'}}>
                        <Text>Name of Bank Account</Text>
                        <Text>Name of Bank</Text>
                        <Text>Branch</Text>
                        <Text>Bank Number</Text>
                        <Text>Bank Account Number</Text>
                        <Text>Swift Code</Text>
                    </View>
                    <View>
                        <Text>: Manpower Staffing Services Singapore Pte Ltd</Text>
                        <Text>: BNP Paribas Singapore Branch</Text>
                        <Text>: Singapore Branch</Text>
                        <Text>: 7418</Text>
                        <Text>: 04151200181</Text>
                        <Text>: BNPASGSG</Text>
                    </View>
                </View>
                <View style={{marginTop: 30}}>
                    <Text style={{lineHeight: 1.2, fontSize: 11}}>
                        This is a computer generated letter and no signature is required.
                    </Text>
                </View>
                {/* <Footer /> */}
            </Page>
        </Document>
    )
}

export default ImmediateTerminationLetter
